import React, { Fragment, useState } from "react";
import dayjs from "dayjs";
import {
  Box,
  Grid,
  IconButton,
  Collapse,
  Stack,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { PhysicalOnePagerResultStyle } from "../assessmentsView/physicalAssessment/PhysicalOnePagerResultStyle";
import VSNTypography from "../../shared/VSNTypography";
import VSNLoader from "../../shared/VSNLoader";
import VSNBreadcrumbs from "../../shared/VSNBreadcrumbs";
import onePagerResultContainer from "../../container/onePager.container";
// import { formatName } from "../../utils/javascript";

export default function AnswerSummaryResult({
  endPointToCall,
  showBreadCrumbs = true,
  breadCrumbAndButton,
  releaseButton,
  breadcrumbsRoutes,
  viewAllResult,
  assessmentUserInfo,
  from,
}) {
  const classes = PhysicalOnePagerResultStyle();
  // const { onePagerAssessmentResult, loader, currentAssessment } =
  //   onePagerResultContainer({ endPointToCall });

  const {
    onePagerAssessmentResult: containerResult,
    loader,
    currentAssessment,
  } = from === "viewAll" ? {} : onePagerResultContainer({ endPointToCall });

  const onePagerAssessmentResult =
    from === "viewAll" ? viewAllResult : containerResult;

  const [openCollapse, setOpenCollapse] = useState(0);
  const isSmallScreen = useMediaQuery("(max-width:900px)");

  const toggleReadMore = (id) => {
    setOpenCollapse((prevState) => (prevState === id ? null : id));
  };

  // const breadcrumbsRoutes = [
  //   {
  //     path: "/assessments",
  //     label: "Assessments",
  //   },
  //   {
  //     // path: `/assessments/${currentAssessment?.assessment_id}`,
  //     label: `${
  //       currentAssessment?.assessment_name ??
  //       onePagerAssessmentResult?.assessment_name
  //     } Dashboard`,
  //   },
  // ];

  if (
    from !== "viewAll" &&
    (loader?.assessmentResult || !onePagerAssessmentResult)
  ) {
    return <VSNLoader variant="fullPage" />;
  }

  // const formatName = (key) => {
  //   return key.replace(/([A-Z])/g, " $1").toUpperCase();
  // };

  const formatName = (key) => {
    return key
      .replace(/_/g, " ")
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, (str) => str.toUpperCase());
  };

  const renderAnswer = (answer) => {
    if (typeof answer === "object" && answer !== null) {
      if (Object.hasOwn(answer, "medication_name")) {
        return (
          <Box style={{ borderBottom: "1px solid black" }}>
            <VSNTypography>
              Medication Name: {answer?.medication_name}
            </VSNTypography>
            <VSNTypography>How Many: {answer?.how_many}</VSNTypography>
            <VSNTypography>How Often: {answer?.how_often}</VSNTypography>
            <VSNTypography>Strength: {answer?.strength}</VSNTypography>
            <VSNTypography>Unit:{answer?.unit}</VSNTypography>
          </Box>
        );
      }

      return Object.keys(answer)?.map((key, index) => {
        const item = answer[key];
        return (
          <div key={index} style={{ borderBottom: "1px solid black" }}>
            {typeof key === "string" && !isNaN(key) === false && (
              <p>
                <strong>{key}</strong>
              </p>
            )}
            {Object.keys(item)?.map((subKey, subIndex) => {
              // if (subKey === "frequency") return null;
              return (
                <div key={subIndex}>
                  {formatName(subKey)}: {item[subKey]}
                </div>
              );
            })}
          </div>
        );
      });
    }

    if (typeof answer === "string" || typeof answer === "number") {
      return answer;
    }

    if (Array.isArray(answer)) {
      return answer?.join(", ");
    }

    return null;
  };

  return (
    <div className={classes.mainLayout}>
      {showBreadCrumbs ? (
        <Box mb={1}>
          <VSNBreadcrumbs {...{ breadcrumbsRoutes }} />
        </Box>
      ) : (
        <Box className={classes.headingButton}>
          <Box>{breadCrumbAndButton}</Box>
          <Box>{onePagerAssessmentResult?.is_locked ? releaseButton : ""}</Box>
        </Box>
      )}

      {from !== "viewAll" && (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <VSNTypography
            fontSize={{ xsm: 24, sm: 34 }}
            sx={{ fontWeight: 700 }}
            mb={1}
          >
            {onePagerAssessmentResult?.assessment_name}
          </VSNTypography>

          {assessmentUserInfo?.submission_date && (
            <Stack
              sx={{
                backgroundColor: "#F2E7F5",
                padding: "8px 12px",
                borderRadius: 1,
              }}
            >
              <VSNTypography fontSize="14px" fontWeight={400}>
                Submission Date :{" "}
                <span
                  style={{
                    fontWeight: "500",
                  }}
                >
                  {dayjs(assessmentUserInfo?.submission_date).format(
                    "MM/DD/YYYY"
                  )}
                </span>
              </VSNTypography>
            </Stack>
          )}
        </Stack>
      )}

      <Box>
        {onePagerAssessmentResult?.result ? (
          <Grid container spacing={3}>
            <Grid item md={12} xs={12}>
              <Stack className={`${classes.assessmentReportCardWhite} main`}>
                <Box sx={{ display: "block" }}>
                  <VSNTypography
                    className={`${classes.mdHeadingMain} super`}
                    dangerouslySetInnerHTML={{
                      __html: onePagerAssessmentResult?.result?.score,
                    }}
                  />
                </Box>
                <Stack direction={{ md: "row" }} mt={1} spacing={2}>
                  <Box flex={1}>
                    <VSNTypography
                      component="p"
                      className={classes.desc}
                      dangerouslySetInnerHTML={{
                        __html: onePagerAssessmentResult?.result?.description,
                      }}
                    />
                  </Box>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        ) : null}

        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            md={onePagerAssessmentResult?.sections?.length === 1 ? 12 : 6}
          >
            {/* {onePagerAssessmentResult?.sections?.map((item, index) =>
              (index + 1) % 2 !== 0 || isSmallScreen ? (
                <Stack
                  className={classes.assessmentReportCardWhite}
                  key={`even-${index}`}
                  sx={{ height: "auto", marginTop: "24px" }}
                >
                  <Box>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <VSNTypography
                        variant="h6"
                        sx={{ fontWeight: "bold" }}
                        className={classes.mdHeadingSecondary}
                      >
                        {index + 1}. {item.title}
                      </VSNTypography>
                      <IconButton
                        onClick={() => toggleReadMore(index)}
                        size="small"
                        className={classes.accordionIcon}
                      >
                        {openCollapse === index ? <CloseIcon /> : <AddIcon />}
                      </IconButton>
                    </Stack>
                    <VSNTypography
                      variant="body2"
                      color="var(--textDarkGray)"
                      sx={{ marginTop: "2px" }}
                    >
                      {item.description}
                    </VSNTypography>
                  </Box>

                  <Collapse in={openCollapse === index}>
                    <Grid container columnSpacing={8} mt={3}>
                      <Grid item xs={12} md={6}>
                        <Box mt={1}>
                          {item?.questions?.map((qa, index) => (
                            <Fragment key={`even-que-${index}`}>
                              {index % 2 === 0 ? (
                                <Box sx={{ marginBottom: "12px" }}>
                                  <VSNTypography
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    {qa.phrase}
                                  </VSNTypography>
                                  <Stack flexDirection="row">
                                    <VSNTypography
                                      variant="body2"
                                      color="var(--textDarkGray)"
                                    >
                                      Ans.&nbsp;
                                    </VSNTypography>
                                    <VSNTypography
                                      variant="body2"
                                      color="#6B7EE9"
                                      sx={{
                                        fontWeight: "bold",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {typeof qa?.answer === "object" &&
                                      !Array?.isArray(qa.answer)
                                        ? Object?.keys(qa.answer)?.map(
                                            (key, index) => {
                                              const item = qa?.answer[key];
                                              return (
                                                <Fragment key={index}>
                                                  <div
                                                    style={{
                                                      borderBottom:
                                                        "1px solid black",
                                                    }}
                                                  >
                                                    {Object?.keys(item)?.map(
                                                      (subKey) => {
                                                        if (
                                                          subKey === "frequency"
                                                        )
                                                          return null;

                                                        return (
                                                          <div key={subKey}>
                                                            {formatName(subKey)}
                                                            : {item[subKey]}
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </div>
                                                </Fragment>
                                              );
                                            }
                                          )
                                        : qa.answer}
                                    </VSNTypography>
                                  </Stack>
                                </Box>
                              ) : (
                                <></>
                              )}
                            </Fragment>
                          ))}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6} key={index}>
                        <Box mt={1} className={classes.insideDivider}>
                          {item?.questions?.map((qa, index) => (
                            <Fragment key={`evrn-odd-${index}`}>
                              {index % 2 !== 0 ? (
                                <Box sx={{ marginBottom: "12px" }}>
                                  <VSNTypography
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    {qa.phrase}
                                  </VSNTypography>
                                  <Stack flexDirection="row">
                                    <VSNTypography
                                      variant="body2"
                                      color="var(--textDarkGray)"
                                    >
                                      Ans.&nbsp;
                                    </VSNTypography>
                                    <VSNTypography
                                      variant="body2"
                                      color="#6B7EE9"
                                      sx={{
                                        fontWeight: "bold",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {qa.answer}
                                    </VSNTypography>
                                  </Stack>
                                </Box>
                              ) : (
                                ""
                              )}
                            </Fragment>
                          ))}
                        </Box>
                      </Grid>
                    </Grid>
                  </Collapse>
                </Stack>
              ) : null
            )} */}

            {onePagerAssessmentResult?.sections?.map((item, index) =>
              (index + 1) % 2 !== 0 || isSmallScreen ? (
                <Stack
                  className={classes.assessmentReportCardWhite}
                  key={`even-${index}`}
                  sx={{ height: "auto", marginTop: "24px" }}
                >
                  <Box>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <VSNTypography
                        variant="h6"
                        sx={{ fontWeight: "bold" }}
                        className={classes.mdHeadingSecondary}
                      >
                        {index + 1}. {item.title}
                      </VSNTypography>
                      <IconButton
                        onClick={() => toggleReadMore(index)}
                        size="small"
                        className={classes.accordionIcon}
                      >
                        {openCollapse === index ? <CloseIcon /> : <AddIcon />}
                      </IconButton>
                    </Stack>
                    <VSNTypography
                      variant="body2"
                      color="var(--textDarkGray)"
                      sx={{ marginTop: "2px" }}
                    >
                      {item.description}
                    </VSNTypography>
                  </Box>

                  <Collapse in={openCollapse === index}>
                    <Grid container columnSpacing={8} mt={3}>
                      <Grid item xs={12} md={6}>
                        <Box mt={1}>
                          {item?.questions?.map((qa, index) => (
                            <Fragment key={`even-que-${index}`}>
                              {index % 2 === 0 ? (
                                <Box sx={{ marginBottom: "12px" }}>
                                  <VSNTypography
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    {qa.phrase}
                                  </VSNTypography>
                                  <Stack flexDirection="row">
                                    <VSNTypography
                                      variant="body2"
                                      color="var(--textDarkGray)"
                                    >
                                      Ans.&nbsp;
                                    </VSNTypography>
                                    <VSNTypography
                                      variant="body2"
                                      color="#6B7EE9"
                                      sx={{
                                        fontWeight: "bold",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {renderAnswer(qa.answer)}
                                    </VSNTypography>
                                  </Stack>
                                </Box>
                              ) : null}
                            </Fragment>
                          ))}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box mt={1} className={classes.insideDivider}>
                          {item?.questions?.map((qa, index) => (
                            <Fragment key={`evrn-odd-${index}`}>
                              {index % 2 !== 0 ? (
                                <Box sx={{ marginBottom: "12px" }}>
                                  <VSNTypography
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    {qa.phrase}
                                  </VSNTypography>
                                  <Stack flexDirection="row">
                                    <VSNTypography
                                      variant="body2"
                                      color="var(--textDarkGray)"
                                    >
                                      Ans.&nbsp;
                                    </VSNTypography>
                                    <VSNTypography
                                      variant="body2"
                                      color="#6B7EE9"
                                      sx={{
                                        fontWeight: "bold",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {renderAnswer(qa.answer)}
                                    </VSNTypography>
                                  </Stack>
                                </Box>
                              ) : null}
                            </Fragment>
                          ))}
                        </Box>
                      </Grid>
                    </Grid>
                  </Collapse>
                </Stack>
              ) : null
            )}
          </Grid>
          <Grid item xs={12} md={6}>
            {onePagerAssessmentResult?.sections?.map((item, index) =>
              (index + 1) % 2 === 0 && !isSmallScreen ? (
                <Stack
                  className={classes.assessmentReportCardWhite}
                  key={`even-${index}`}
                  sx={{ height: "auto", marginTop: "24px" }}
                >
                  <Box>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <VSNTypography
                        variant="h6"
                        sx={{ fontWeight: "bold" }}
                        className={classes.mdHeadingSecondary}
                      >
                        {index + 1}. {item.title}
                      </VSNTypography>
                      <IconButton
                        onClick={() => toggleReadMore(index)}
                        size="small"
                        className={classes.accordionIcon}
                      >
                        {openCollapse === index ? <CloseIcon /> : <AddIcon />}
                      </IconButton>
                    </Stack>
                    <VSNTypography
                      variant="body2"
                      color="var(--textDarkGray)"
                      sx={{ marginTop: "2px" }}
                    >
                      {item.description}
                    </VSNTypography>
                  </Box>

                  <Collapse in={openCollapse === index}>
                    <Grid container columnSpacing={8} mt={3}>
                      <Grid item xs={12} md={6}>
                        <Box mt={1}>
                          {item?.questions?.map((qa, index) => (
                            <Fragment key={`even-que-${index}`}>
                              {index % 2 === 0 ? (
                                <Box sx={{ marginBottom: "12px" }}>
                                  <VSNTypography
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    {qa.phrase}
                                  </VSNTypography>
                                  <Stack flexDirection="row">
                                    <VSNTypography
                                      variant="body2"
                                      color="var(--textDarkGray)"
                                    >
                                      Ans.&nbsp;
                                    </VSNTypography>
                                    <VSNTypography
                                      variant="body2"
                                      color="#6B7EE9"
                                      sx={{
                                        fontWeight: "bold",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {renderAnswer(qa.answer)}
                                    </VSNTypography>
                                  </Stack>
                                </Box>
                              ) : null}
                            </Fragment>
                          ))}
                        </Box>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Box mt={1} className={classes.insideDivider}>
                          {item?.questions?.map((qa, index) => (
                            <Fragment key={`evrn-odd-${index}`}>
                              {index % 2 !== 0 ? (
                                <Box sx={{ marginBottom: "12px" }}>
                                  <VSNTypography
                                    variant="body2"
                                    color="text.primary"
                                  >
                                    {qa.phrase}
                                  </VSNTypography>
                                  <Stack flexDirection="row">
                                    <VSNTypography
                                      variant="body2"
                                      color="var(--textDarkGray)"
                                    >
                                      Ans.&nbsp;
                                    </VSNTypography>
                                    <VSNTypography
                                      variant="body2"
                                      color="#6B7EE9"
                                      sx={{
                                        fontWeight: "bold",
                                        fontStyle: "italic",
                                      }}
                                    >
                                      {renderAnswer(qa.answer)}
                                    </VSNTypography>
                                  </Stack>
                                </Box>
                              ) : null}
                            </Fragment>
                          ))}
                        </Box>
                      </Grid>
                    </Grid>
                  </Collapse>
                </Stack>
              ) : null
            )}
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
